import React from 'react';
import { H6, P } from './text';
import { IHistorischeStatistieken } from '../models/page';

export interface IPlayOffsWinnaarTableProps {
	results: IHistorischeStatistieken;
}

export default function PlayOffsWinnaarTable({ results }: IPlayOffsWinnaarTableProps) {
	const winnaars = results.playOffsWinnaar?.winnaars ?? [];

	if (winnaars.length === 0) {
		return (
			<div className="bg-white py-12 sm:py-16 mb-4">
				<div className="mx-auto max-w-7xl px-6 lg:px-8">
					<P>Geen data beschikbaar.</P>
				</div>
			</div>
		);
	}

	return (
		<div className="bg-white py-12 sm:py-16 mb-4">
			<div className="mx-auto max-w-7xl px-6 lg:px-8">
				{winnaars.map((winnaar, index) => (
					<div key={index} className="mb-12">
						<div className="mx-auto max-w-4xl lg:mx-0">
							<h2 className="text-3xl font-bold tracking-tight sm:text-4xl">
								{winnaar.seizoensTitel}
							</h2>
						</div>
						<ul
							role="list"
							className="mx-auto mt-4 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-3"
						>
							<li>
								{winnaar.club?.img && (
									<img
										className="aspect-[1/1] w-full rounded-2xl object-cover"
										src={winnaar.club.img.sourceUrl}
										alt={winnaar.club.img.altText}
									/>
								)}
								<H6 className="mt-4">{winnaar.club?.naam}</H6>
							</li>
						</ul>
					</div>
				))}
			</div>
		</div>
	);
}
